import Api from './Api';
const endPoint = 'Application';
const userPoint = 'User';

const getApplications = applications => Api.post(`${endPoint}/filter`, applications);
const saveApplication = application => Api.post(`${endPoint}/save`, application);
const getUsers = user => Api.get(`${userPoint}/get`, { params: { userFilter: user } });
const updatestatus = application => Api.post(`${endPoint}/activatedeactivate`, application);
const hasAdminRights = user => Api.post(`${userPoint}/HasAdminRights`, user);
const isSuperAdmin = user => Api.post(`${userPoint}/IsSuperAdmin`, user);

export {
    getApplications,
    saveApplication,
    getUsers,
    updatestatus,
    hasAdminRights,
    isSuperAdmin
};